import { render, staticRenderFns } from "./expand.vue?vue&type=template&id=6a39f919&scoped=true"
import script from "./expand.vue?vue&type=script&lang=js"
export * from "./expand.vue?vue&type=script&lang=js"
import style0 from "./expand.vue?vue&type=style&index=0&id=6a39f919&prod&lang=scss&scoped=true"
import style1 from "./expand.vue?vue&type=style&index=1&id=6a39f919&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a39f919",
  null
  
)

export default component.exports